export default __webpack_public_path__ + "img/f28ca1e3aa37364abd1fe6b34df903b5.svg";